export enum ShiftSwapStateEnums {
  DISABLED,
  NONE,
  PENDING_SHIFT_DROP,
  PENDING_PICKUP_APPROVAL,
  SHIFT_PICKED_UP,
}
